import 'css-chunk:../authentication/frontend/components/phi-earphones/index.module.scss';export default {
  "earphones": "_earphones_16168_1"
};